import { useEffect, useState } from 'react'
import useDebounce from './useDebounce'
import setUrlParam from './setUrlParam'

export default function Filters ({
  subjects, areas, ageGroups, strings, filters, setFilters,
}) {
  const [search, setSearch] = useState(filters.search || '')
  const debouncedSearch = useDebounce(search, 300)
  const terms = [
    { name: 'subject', label: strings.subject, options: subjects },
    { name: 'area', label: strings.area, options: areas },
    { name: 'ageGroup', label: strings.ageGroup, options: ageGroups },
  ]

  const updateFilters = (name, value) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [name]: value,
      currentPage: 1,
    }))

    setUrlParam(name, value)
  }

  const handleChange = (e) => updateFilters(e.target.name, e.target.value)

  const handleClearFiltersClick = () => {
    setSearch('')
    setFilters({
      subject: '',
      area: '',
      ageGroup: '',
      search: '',
      currentPage: 1,
    })

    const url = new URL(window.location.href)
    url.search = ''
    window.history.replaceState({}, '', url)
  }

  useEffect(() => {
    if (debouncedSearch !== filters.search) {
      updateFilters('search', debouncedSearch)
    }
  }, [debouncedSearch])

  return (
    <div className="mtt-activities__filters">

      {terms.map(({ name, label, options }) => (
        options.length > 0 && (
          <div className="mtt-activities__filter" key={name}>
            <div className="mtt-activities__filter-label">
              {label}:
            </div>
            <select
              className="mtt-activities__filter-select"
              name={name}
              onChange={handleChange}
              value={filters[name]}
            >
              <option value="">{strings.all}</option>
              {options.map(field => (<option
                key={field.term_id}
                value={field.term_id}
              >
                {field.name}
              </option>))}
            </select>
          </div>
        )
      ))}

      <div className="mtt-activities__filter">
        <div className="mtt-activities__filter-label">
          {strings.search}:
        </div>
        <input
          type="search"
          name="search"
          placeholder={strings.search}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <button onClick={handleClearFiltersClick} className={'button primary'}>
        {strings.clearFilters}
      </button>
    </div>
  )
}